import React from 'react';
import { Activity } from 'lucide-react';
import { ConnectionStatus } from '../ui/ConnectionStatus';

export const Header: React.FC = () => {
  return (
    <header
      className="flex-shrink-0 px-6 py-3 flex items-center justify-between"
      style={{
        background: 'rgba(5,14,36,0.8)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      {/* Brand */}
      <div className="flex items-center gap-3">
        <div className="relative">
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #0ea5e9, #14b8a6)' }}
          >
            <Activity className="w-5 h-5 text-white" />
          </div>
          <div
            className="absolute inset-0 rounded-xl opacity-60 blur-md"
            style={{ background: 'linear-gradient(135deg, #0ea5e9, #14b8a6)' }}
          />
        </div>
        <div>
          <h1 className="text-xl font-bold leading-none gradient-text tracking-tight">
            LibrasMed
          </h1>
          <p className="text-[10px] text-slate-500 mt-0.5 font-medium tracking-widest uppercase">
            Comunicação em Libras
          </p>
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-4">
        <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full"
          style={{ background: 'rgba(14,165,233,0.08)', border: '1px solid rgba(14,165,233,0.15)' }}>
          <span className="text-xs text-slate-400 font-medium">163 sinais</span>
          <span className="w-1 h-1 rounded-full bg-slate-600" />
          <span className="text-xs text-teal-400 font-semibold">96% cobertura</span>
        </div>
        <ConnectionStatus />
      </div>
    </header>
  );
};
